import { useState } from 'react';
import { IconEye, IconEyeOff } from '@tabler/icons-react';

import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from '@/components/ui/input-group';

interface PasswordInputProps extends React.ComponentProps<typeof InputGroupInput> {
  showPasswordLabel?: string;
  hidePasswordLabel?: string;
}

export function PasswordInput({
  showPasswordLabel = 'Показать пароль',
  hidePasswordLabel = 'Скрыть пароль',
  onKeyDown,
  ...props
}: PasswordInputProps) {
  const [isVisible, setIsVisible] = useState(false);

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    onKeyDown?.(e);
    if (e.defaultPrevented || e.key !== 'Enter' || e.shiftKey || e.nativeEvent.isComposing) {
      return;
    }
    const form = e.currentTarget.form;
    if (!form) {
      return;
    }
    e.preventDefault();
    form.requestSubmit();
  }

  return (
    <InputGroup>
      <InputGroupInput
        {...props}
        onKeyDown={handleKeyDown}
        type={isVisible ? 'text' : 'password'}
      />
      <InputGroupAddon align="inline-end">
        <InputGroupButton
          type="button"
          variant="ghost"
          size="icon-xs"
          aria-label={isVisible ? hidePasswordLabel : showPasswordLabel}
          onClick={() => setIsVisible((visible) => !visible)}
        >
          {isVisible ? <IconEyeOff /> : <IconEye />}
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  );
}
